import { useTranslation } from '@e-kyc/translations';

import { Button, LoadingSpinner, Modal } from '../../../../../components';
import type { EkycStep } from '../../../../../providers';

interface CaptureBackModalProps {
  isOpen: boolean;
  hasError: boolean;
  isLoading: boolean;
  setStep: (step: EkycStep) => void;
  resetCamera: () => void;
  close: () => void;
}

function CaptureBackModal(props: CaptureBackModalProps) {
  const { isOpen, hasError, isLoading, setStep, resetCamera, close } = props;

  const { t } = useTranslation();

  return (
    <Modal open={isOpen} className='w-full max-w-[343px]'>
      {hasError ? (
        <div className='flex w-full flex-col items-center justify-center'>
          <div className='flex flex-col items-center justify-center gap-4 p-6 pt-10'>
            <img src='id_back_failed.png' alt='back id failed icon' />
            <div className='flex flex-col items-center justify-center gap-2'>
              <h5 className='text-error mt-4 font-semibold'>
                {t('capture.modal.back.failed.title')}
              </h5>
              <div className='text-body-1 text-text-secondary text-center'>
                {t('capture.modal.failed.description')}
              </div>
            </div>
          </div>
          <div className='w-full p-4'>
            <Button
              className='w-full'
              onClick={() => {
                close();
                resetCamera();
              }}
            >
              {t('button.retry')}
            </Button>
          </div>
        </div>
      ) : !isLoading ? (
        <div className='flex w-full flex-col items-center justify-center'>
          <div className='flex flex-col items-center justify-center gap-4 p-6 pt-10'>
            <img src='id_back_passed.png' alt='back id passed icon' />
            <div className='flex flex-col items-center justify-center gap-2'>
              <h5 className='mt-4 font-semibold'>{t('capture.modal.back.success.title')}</h5>
              <div className='text-body-1 text-text-secondary'>
                {t('capture.modal.back.success.description')}
              </div>
            </div>
          </div>
          <div className='w-full p-4'>
            <Button
              className='w-full'
              onClick={() => {
                setStep('id-card-confirmation');
              }}
            >
              {t('button.next')}
            </Button>
          </div>
        </div>
      ) : (
        <div className='flex w-full flex-col items-center justify-center gap-4 py-6'>
          <div className='flex size-12 flex-col items-center justify-center'>
            <LoadingSpinner />
          </div>
          <h5>{t('capture.modal.loading')}</h5>
        </div>
      )}
    </Modal>
  );
}

export default CaptureBackModal;
